require("!!/home/silverwing/source/instead-js/node_modules/script-loader/addScript.js")(require("!!/home/silverwing/source/instead-js/node_modules/raw-loader/index.js!/home/silverwing/source/instead-js/instead/lua.vm.js"))


//////////////////
// WEBPACK FOOTER
// ./~/script-loader!./instead/lua.vm.js
// module id = 140
// module chunks = 0